/**
 * Store for tracking scroll locations and what scroll post is in view.
 */
import { observable } from 'mobx';

export enum ScrollDirection {
    DOWN,
    UP,
}

export class StreamStore {
    @observable activePost = 0;
    @observable scrollLocation = 0;
    @observable scrollDirection = ScrollDirection.DOWN;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/StreamStore.ts